import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function PerformansKaygisiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['performans-kaygisi-testi']} />;
}
